




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { LaborOpCode } from '@/models/admin/laboropcode';
import { Base } from '@/components/common/base';
import { laborOpCodeService, storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['isDialog', 'addressDialog', 'methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class LaborOpCodeAddPage extends Base {
  get trigger(): boolean {
    return this.$props.dialog;
  }
  set trigger(val) {
    this.$emit('closedialog', val);
  }
  public isDialog: boolean;
  public form: any = {};
  public laborOpCodefields: Array<VFields<any>> = [];
  public valid: boolean = true;
  public laborOpCode: LaborOpCode = {
    operationCode: '',
    description: '',
  };
  public storeId: number = 0;
  public isAddUpdateButton = true;
  public disableSubmitButton = false;
  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.laboropcode.list',
        params: { storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('laborOpCode.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitLaborOpCode();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('laborOpCode.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('laborOpCode.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'laborOpCode');

    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.id) {
      this.getLaborOpCodeById();
    }
  }
  public async getLaborOpCodeById(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.laborOpCodefields);
      const resp = await laborOpCodeService.getLaborOpCodeById(
        Number(this.$route.params.id),
        this.storeId
      );
      if (resp) {
        this.laborOpCode = resp;
      }
    } finally {
      this.formlyHideSkeleton(this.laborOpCodefields);
    }
  }
   
  public validateLaborOpCode(): Vue & { validate: () => boolean } {
    return this.$refs.laborOpCodeForm as Vue & { validate: () => boolean };
  }

  public async submitLaborOpCode(): Promise<void> {
    if(this.validateLaborOpCode().validate()){
      this.isAddUpdateButton = false;
      const data = this.laborOpCode;
      if (this.$route.params.id) {
        try {
          this.addLoader();
          this.disableSubmitButton = true;
          this.$emit('update:progress', this.disableSubmitButton);
          await laborOpCodeService.updateLaborOpCode(
            this.laborOpCode,
            this.storeId
          );
          this.showAlert(true, this.$t('laborOpCode.alertUpdateLaborOpCode'));
          this.backToList();
          this.isAddUpdateButton = true;
        } finally {
          this.removeLoader();
          this.disableSubmitButton = false;
          this.isAddUpdateButton = true;
          this.$emit('update:progress', this.disableSubmitButton);
        }
      } else {
        try {
          this.disableSubmitButton = true;
          this.$emit('update:progress', this.disableSubmitButton);
          await laborOpCodeService.addLaborOpCode(this.laborOpCode, this.storeId);
          this.showAlert(true, this.$t('laborOpCode.alertSaveLaborOpCode'));
          this.backToList();
          this.isAddUpdateButton = true;
        } finally {
          this.disableSubmitButton = false;
          this.isAddUpdateButton = true;
          this.$emit('update:progress', this.disableSubmitButton);
        }
      }
    }
  }

  public setFields(): void {
    this.laborOpCodefields = [
      // Name
      {
        key: 'operationCode',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'laborOpCode.laborOpCodeFields.operationCode'
          ) as string,
          required: true,
          disabled: false,
          events: {
            onChange: (str) => {
              return (this.laborOpCode.operationCode = str.toUpperCase());
            },
          },
          loading: false,
          rules:[
            v => this.required('Operation Code',v)
          ]
        },
      },
      {
        key: 'description',
        type: 'v-alynk-textarea',
        required: true,
        templateOptions: {
          counter: 255,
          label: this.$t('laborOpCode.laborOpCodeFields.description') as string,
          required: false,
          disabled: false,
          loading: false,
        },
      },
    ];
  }

  public backToList() {
    if (this.isDialog) {
      this.trigger = false;
      this.laborOpCode = {};
    } else {
      this.$router.push({
        name: 'admin.laboropcode.list',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
}
